import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-wrapper',
    template: `
        <div class="form-group" [class.has-error]="showError">
            <field-validation-indicator
                [control]="formControl"
                [placement]="'left'"
                class="pull-right"
            ></field-validation-indicator>
            <label *ngIf="to.label && to.hideLabel !== true" [attr.for]="id">
                {{ to.label }}
            </label>
            <ng-template #fieldComponent></ng-template>
            <div
                *ngIf="showError"
                class="invalid-feedback"
                [style.display]="'block'"
            >
                <validation-messages
                    [control]="formControl"
                ></validation-messages>
            </div>
            <p *ngIf="to.description" class="help-block">
                {{ to.description }}
            </p>
        </div>
    `
})
export class FormlyWrapperFormField extends FieldWrapper {
    @ViewChild('fieldComponent', { read: ViewContainerRef, static: true })
    fieldComponent!: ViewContainerRef;
}
